import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IWorkflow, IWorkflowInitialState } from "./workflowModel";
import {
  ActiveInactiveWorkflow,
  createWorkflow,
  deleteWorkflow,
  getAllActiveWorkflows,
  getAllWorkflows,
  getWorkflowByID,
  updateWorkflow,
  WorkflowDetailsImageUpload,
} from "./services/workflow.services";

const initialState: IWorkflowInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  WorkflowID: null,
  WorkflowList: [],
  WorkflowDetail: {
    Title: "",
    ShortDescription: "",
    LongDescription: "",
    SequenceNo: null,
    IsActive: 1,
  },
};

const workflowSlice = createSlice({
  name: "workflow",
  initialState,
  reducers: {
    clearWorkflowDetails: (state) => {
      state.WorkflowDetail = initialState.WorkflowDetail;
    },
    setWorkflowID: (state, action) => {
      state.WorkflowID = action.payload;
    },
    clearWorkflowID: (state) => {
      state.WorkflowID = initialState.WorkflowID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllWorkflows.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllWorkflows.fulfilled,
      (state, action: PayloadAction<IWorkflow[]>) => {
        state.loading = false;
        state.WorkflowList = action.payload || [];
      }
    );
    builder.addCase(getAllWorkflows.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.WorkflowList = [];
    });
    builder.addCase(createWorkflow.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createWorkflow.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createWorkflow.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateWorkflow.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateWorkflow.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateWorkflow.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteWorkflow.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteWorkflow.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteWorkflow.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getWorkflowByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getWorkflowByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.WorkflowDetail = action.payload;
    });
    builder.addCase(getWorkflowByID.rejected, (state, action) => {
      state.loading = false;
      state.WorkflowDetail = initialState.WorkflowDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveWorkflows.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveWorkflows.fulfilled,
      (state, action: PayloadAction<IWorkflow[]>) => {
        state.loading = false;
        state.WorkflowList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveWorkflows.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.WorkflowList = [];
    });
    builder.addCase(ActiveInactiveWorkflow.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveWorkflow.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveWorkflow.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(WorkflowDetailsImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(WorkflowDetailsImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(WorkflowDetailsImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearWorkflowDetails, clearWorkflowID, setWorkflowID } =
  workflowSlice.actions;
export default workflowSlice.reducer;
